import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';

import { getValidationClass } from '@/utils/formUtils';
import FormError from '@/components/common/form/FormError';
import { ERROR_TYPE, FIELD_TYPE, POSTAL_CODE_REGEX } from '@/constants/form';

const PostalCodeField = ({
  id, name, className, isRequired, country, ...rest
}) => {
  const { register, formState, formState: { errors }, clearErrors } = useFormContext();

  const isPostalCodeValidated = async (newPc) => {
    if (newPc && !newPc.match(POSTAL_CODE_REGEX[country])) {
      return false;
    }
    clearErrors(name);
    return true;
  };

  const validate = Object.fromEntries([
    [ERROR_TYPE.POSTAL_CODE, isPostalCodeValidated]
  ]);

  return (
    <>
      <input
        id={id}
        data-rbf={`input${id ? '-' + id : ''}`}
        type={FIELD_TYPE.TEXT}
        className={[
          'form-control',
          className,
          getValidationClass(name, formState)
        ].filter(Boolean).join(' ')}
        name={name}
        {...register(name, {
          required: isRequired,
          validate
        })}
        {...rest}
      />
      {errors?.[name] && <FormError error={errors[name]} />}
    </>
  );
};

PostalCodeField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  isRequired: PropTypes.bool,
  country: PropTypes.string
};

export default PostalCodeField;
